<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button size="small" class="btn" type="primary" v-if="show.qr" @click="handleCreate">维保确认</el-button>
        <!-- <el-button size="small" type="primary" disabled="true" class="btn">导出列表</el-button> -->
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item label="筛选单位">
            <el-cascader
            v-model="deviceInfo.companyCode" 
              :options="companyTree"
              :show-all-levels="false"
              :props="props"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="maintenanceData" tooltip-effect="dark"
          style="width: 100%;text-align: center" stripe>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column :label="lable.index" type="index" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" :label="lable.id" width="170" show-overflow-tooltip>
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="onClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="glbh" :label="lable.glbh" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="zcmc" :label="lable.zcmc" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ssdw" :label="lable.ssdw" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="reason" :label="lable.reason" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="startTime" :label="lable.startTime" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="endTime" :label="lable.endTime" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="maintainMany" :label="lable.maintainMany" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="equipment" :label="lable.equipment" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="project" :label="lable.project" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '3'" style="color:yellowgreen">待确认</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="maintenanceData.length > 0" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>

    <!--------------------------------------------------------------------维保确认弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" title="维保确认"
      style="width:100% !important;margin-left: 5%;">
      <el-form :model="questionForm" ref="dataForm" size="mini" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.id" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12"> <el-form-item :label="lable.zcmc">
              <el-input :readonly="true" v-model="questionForm.zcmc" />
            </el-form-item></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.ssdw" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.ssdw" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.applyTime">
              <el-input :readonly="true" v-model="questionForm.applyTime" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.userName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.companyName">
              <el-input :readonly="true" v-model="questionForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.reason" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.reason" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.wbr">
              <el-input :readonly="true" v-model="questionForm.wbrxm" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.tel" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.personTel" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.maintainMany">
              <el-input :readonly="true" v-model="questionForm.maintainMany" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.startTime" style="width:90%">
              <el-date-picker v-model="questionForm.startTime" style="width:100%" value-format="yyyy-MM-dd" width="100%"
                :readonly="true" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.endTime">
              <el-date-picker v-model="questionForm.endTime" style="width:100%" value-format="yyyy-MM-dd" width="100%"
                :readonly="true" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.equipment" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.equipment" />
            </el-form-item>
          </el-col>
          <el-col :span="12">

            <el-form-item :label="lable.project">
              <el-input :readonly="true" v-model="questionForm.project" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label="lable.processReson">
          <el-input type="textarea" :rows="2" :readonly="true" v-model="questionForm.processReson">
          </el-input>
        </el-form-item>
        <el-form-item label="附件资料">
          <el-table :data="fileData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip >
            </el-table-column>
            <el-table-column label="id" v-if="false"> </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>

              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="维保类型" style="width:90%">
              <el-input v-if="questionForm.maintenanceType == '0'" :readonly="true" value="设备维修" />
              <el-input v-else-if="questionForm.maintenanceType == '1'" :readonly="true" value="设备保养" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维保结果">
              <el-input :readonly="true" v-model="questionForm.result" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否需要检定/校准">
              <el-radio-group v-model="questionForm.sout" style="width:100%">
                <el-radio label="0"> 需要</el-radio>
                <el-radio label="1">不需要</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.evaluate">
              <div style="float:left;">
              <el-rate v-model="questionForm.evaluate" style="width:100%;float:left" show-text :texts="pj"> </el-rate>
              </div>
              <!-- <el-rate  v-model="questionForm.evaluate"   style="width:100%;float:left" show-text :texts="pj"> </el-rate> -->

            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.remark">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="questionForm.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpdate"
          v-preventReClick>提交</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>
<script>
import {
  selectAllMaintenance,
  notarizeMaintenance, findByRoleUser, findByIdFile, findByModule,findByUserIdCompanyTree 
} from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'

export default {
  name: "Notarize",
  components: {
    "FilePreview": FilePreview,
  },
  data() {
    return {
      companyTree:[],
      props: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
      },
      deviceInfo: {
        date: [],
        content: "",
        state: "",
      },
      lable: {},
      show: {
        qr: false
      },
      fileData: [],
      pj: [
        "非常差",
        "差",
        "一般",
        "好",
        "非常好"
      ],
      resultOptions: [
        {
          value: "已修复",
          label: "已修复"
        }, {
          value: "部分修复",
          label: "部分修复"
        }, {
          value: "未修复",
          label: "未修复"
        },
      ],
      previewTitle: '',
      docxdialog: false,
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      // options: [],
      maintenanceData: [],
      multipleTable: [],
      dialogFormVisible: false,
      questionForm: {},
    };
  },
  methods: {

    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.name);
    },
    yulan(row) {
      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
      // this.downloadUtil.preview(row.path)
    },
    onClick(row) {
      if (this.show.qr) {
        this.questionForm = {}
        this.questionForm = row;
        this.findByIdfile(row.id)
        this.dialogFormVisible = true;
      } else {
        this.$message.warning("您不具有该权限")
      }
    },
    findAllClick(){
      this.pageIndex=1
      this.findAll()
    },
    handleCreate() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条信息"); // .....失败信息
      } else if (currentSelect.length == 1) {
        this.questionForm = currentSelect[0];
        this.findByIdfile(currentSelect[0].id)
        this.dialogFormVisible = true;
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },
    submitUpdate() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      notarizeMaintenance(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.dialogFormVisible = false;
          this.findAll();
          this.questionForm = {};
          this.$message({
            message: "确认成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //查找所有维保信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: "3",
         companyCode:null
      };
      if(this.deviceInfo.companyCode!=null){
        map.companyCode=this.deviceInfo.companyCode[this.deviceInfo.companyCode.length-1] 
      }
      selectAllMaintenance(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.maintenanceData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize);
          this.total = this.data.length;
        }
      });
    },
    //根据id查找文件
    findByIdfile(id) {
      findByIdFile(id).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.maintenanceData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.maintenanceData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
    findLable() {
      findByModule("维保管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var  companyCode='';
      if (userinfo.userRole == 1 || (userinfo.fjqx != null && (userinfo.fjqx.indexOf ("3")!=-1||userinfo.fjqx.indexOf ("4")!=-1))) {
        companyCode="-1"
      }else{
        companyCode=userinfo.companyCode
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyTree = this.getTreeData(data);
        } 
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
  },
  created() {
    this.getCompanyTree();
    this.findLable();
    this.findAll();
    // this.findRoleUser();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "106") {
        this.show.qr = true;
      }
    })
  },
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/maintenance/Notarize.vue